import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import AOS from 'aos'
import 'aos/dist/aos.css'
import VueAnime from 'vue-animejs'
import VueAnalytics from 'vue-analytics'
import VueTypedJs from 'vue-typed-js'
import VueMeta from 'vue-meta'

// you don't need it. this is for example purposes

import './registerServiceWorker'
import wb from './registerServiceWorker'

Vue.prototype.$workbox = wb

Vue.use(VueMeta)
Vue.use(VueTypedJs)
Vue.use(VueAnime, VueAnalytics, {
  id: 'UA-102441092-1',
  router
})

Vue.config.productionTip = false

// Vue.directive('lazyload', LazyLoadDirective)

new Vue({
  created() {
    AOS.init()
  },
  router,
  i18n,
  render: h => h(App)
}).$mount('#app', true)
